<script>
  //on exporte pour pouvoir modifier le titre de l'extérieur du component (depuis ExpensesList)
  //le titre par défaut sera "Dépense anonyme"
  export let title = "Anonyme";
</script>

<div class="">
  <h2>{title}</h2>
</div>

<style>
</style>
